import { GzIconWebComponent } from './component/GzIconWebComponent';

export { GzIconWebComponent };
